import { MfeShareableOutlet, isSidePanelShareable, useShareable } from 'features/mfe_shareable';
import { RightRailOutlet } from 'features/right_rail';
import { UserGuidePanelContent, useIsUserGuideExpanded } from 'features/user_guide';
import { ShellSidePanelCompactProvider } from 'shared/shell_layout';
import { SHELL_SIDE_PANEL_CONTENT_TEST_ID } from 'shared/shell_layout/constants';
const sidePanelContentCss = "sv27i0";

/** Fills the panel so route panes can use `height: 100%` + `SidePanelPaneLayout`. */
const sidePanelPaneHostCss = "s1362bqq";
export const SidePanelContent = () => {
  const {
    isOpen: isShareableOpen,
    current: currentShareable
  } = useShareable();
  const isUserGuideExpanded = useIsUserGuideExpanded();
  const isSidePanelShareableOpen = isShareableOpen && isSidePanelShareable(currentShareable?.shareable);
  return <ShellSidePanelCompactProvider>
      {ref => <div ref={ref} className={sidePanelContentCss} data-testid={SHELL_SIDE_PANEL_CONTENT_TEST_ID}>
          <div className={sidePanelPaneHostCss} data-testid="shell-side-panel-pane-host">
            {isSidePanelShareableOpen && <MfeShareableOutlet />}
            {/* Always mount so useUrlSync stays alive when the panel is briefly
                closed during pathname-only nav (preserves pane/paneState). */}
            <RightRailOutlet />
            {isUserGuideExpanded && <UserGuidePanelContent />}
          </div>
        </div>}
    </ShellSidePanelCompactProvider>;
};

require("./SidePanelContent.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SidePanelContent.tsx");